import { render, staticRenderFns } from "./ProductGalleryIncipit.vue?vue&type=template&id=29e9b852&scoped=true"
import script from "./ProductGalleryIncipit.vue?vue&type=script&lang=ts"
export * from "./ProductGalleryIncipit.vue?vue&type=script&lang=ts"
import style0 from "./ProductGalleryIncipit.vue?vue&type=style&index=0&id=29e9b852&prod&scoped=true&lang=css"
import style1 from "./ProductGalleryIncipit.vue?vue&type=style&index=1&id=29e9b852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e9b852",
  null
  
)

export default component.exports